import { useEffect } from 'react';

import { Divider, Stack, Typography } from '@mui/material';

import { SideModal } from '@/components';

import ArrestChargeInfoForm from './ArrestChargeInfoForm';
import ArrestFileForm from './ArrestFileForm';
import FileDescriptionForm from './FileDescriptionForm';
import { useKaseArrestsContext } from '../KaseArrestsContext';

const ArrestModal = () => {
  const {
    arrestDrawer,
    setArrestDrawer,
    setCurrentArrestFile,
    setCurrentArrestCharge,
  } = useKaseArrestsContext();

  const handleClose = () => {
    setArrestDrawer(null);
  };

  useEffect(() => {
    if (!arrestDrawer) {
      setCurrentArrestFile(undefined);
      setCurrentArrestCharge(undefined);
    }
  }, [arrestDrawer]);

  const getDrawerTitle = () => {
    switch (arrestDrawer) {
      case 'charge':
        return 'Arrest charge information';
      case 'file':
        return 'Arrest files';
      case 'description':
        return 'Edit description';
      default:
        return '';
    }
  };

  const getModalForm = () => {
    switch (arrestDrawer) {
      case 'charge':
        return <ArrestChargeInfoForm />;
      case 'file':
        return <ArrestFileForm />;
      case 'description':
        return <FileDescriptionForm />;
      default:
        return '';
    }
  };

  return (
    <SideModal open={!!arrestDrawer} onClose={handleClose}>
      <Stack
        sx={{
          height: '100%',
          padding: '20px',
        }}
      >
        <Typography
          variant="h2"
          sx={{
            fontWeight: 600,
            fontSize: '1.5rem',
            marginBottom: '20px',
            lineHeight: '24px',
          }}
        >
          {getDrawerTitle()}
        </Typography>
        <Divider />
        {getModalForm()}
      </Stack>
    </SideModal>
  );
};

export default ArrestModal;
